/**
 * Learning Center API: the player's bookmark (plan docs/plans/lms-plan.md
 * Appendix A "Progress, attempts, completions"; 5.5 lms_progress, 7.2, 11.3,
 * 18.15; WP-34's routes, WP-40's client).
 *
 *   GET /me/progress/:courseId?version_id=  -> progress | null (the version the
 *                                              person trains on unless named)
 *   PUT /me/progress/:courseId              -> the saved progress
 *
 * The bookmark is not a record (5.5). The server keeps the gates honest: it
 * unions slides_seen, derives slides_done from it (18.15: a client's claim is
 * not taken), and keeps reading_done true once set. So the player never sends
 * slides_done; it sends the slides it has seen and reads the answer back.
 */
import api from '../../services/api';

/** lms_progress as the route answers it (5.5). */
export interface LmsProgress {
  user_id?: string;
  course_version_id: string;
  last_slide_id: string | null;
  slides_seen: string[];
  /** Server-derived: every slide of the version seen (18.15). */
  slides_done: boolean;
  reading_opened_at?: string | null;
  reading_done: boolean;
  updated_at?: string;
}

/** PUT body (Appendix A; reading_opened stamps reading_opened_at once, WP-34). */
export interface ProgressSave {
  course_version_id: string;
  last_slide_id?: string;
  slides_seen?: string[];
  reading_done?: boolean;
  reading_opened?: boolean;
}

const enc = encodeURIComponent;

/** GET /api/lms/me/progress/:courseId (null when there is no bookmark yet). */
export async function getMyProgress(courseId: string, versionId?: string | null): Promise<LmsProgress | null> {
  const config = versionId ? { params: { version_id: versionId } } : undefined;
  const response = await api.get<LmsProgress | null>(`/api/lms/me/progress/${enc(courseId)}`, config);
  return response.data ?? null;
}

/** PUT /api/lms/me/progress/:courseId */
export async function saveMyProgress(courseId: string, body: ProgressSave): Promise<LmsProgress> {
  const response = await api.put<LmsProgress>(`/api/lms/me/progress/${enc(courseId)}`, body);
  return response.data;
}
